import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { getInitials } from "@/lib/format";
import { cn } from "@/lib/utils";
import { imageUrl } from "../../../shared/image-url";

interface UserAvatarProps extends React.ComponentPropsWithoutRef<typeof Avatar> {
  avatarUrl?: string | null;
  name?: string | null;
  /** Tailwind text-size class for the fallback initials, e.g. "text-sm". Defaults to "text-sm". */
  fallbackClassName?: string;
  /** Render size in px (used for both width and height). Defaults to 100. */
  previewSize?: number;
}

/**
 * Single-tag replacement for the Avatar + AvatarImage + AvatarFallback trio.
 * Handles preview URL construction and initials.
 */
export function UserAvatar({
  avatarUrl,
  name,
  fallbackClassName,
  previewSize = 100,
  className,
  ...props
}: UserAvatarProps) {
  const src = imageUrl(avatarUrl, {
    width: previewSize,
    height: previewSize,
    fit: "cover",
  });
  return (
    <Avatar className={cn("shrink-0", className)} {...props}>
      {src && <AvatarImage src={src} alt={name ?? ""} />}
      <AvatarFallback className={fallbackClassName}>{getInitials(name)}</AvatarFallback>
    </Avatar>
  );
}
